
import { IsNotEmpty } from 'class-validator';
import { EpimsBaseEntityDto } from './epim-base.dto';

export class GroundRentRateDto extends EpimsBaseEntityDto {

  @IsNotEmpty()
  MeasureId: string;
  Rate: number;
  Unit: number;
  Status: boolean;
  RateDate: string;
  Remarks: string;
  CurrencyId: string;
}
